import { render, staticRenderFns } from "./DownLoadCenterAndAFK.vue?vue&type=template&id=8bec2c7c&"
import script from "TY/components/Download/DownLoadCenterAndAFK.component?vue&type=script&lang=js&"
export * from "TY/components/Download/DownLoadCenterAndAFK.component?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports